<template>
  <div class="container">
    <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>
    <!--列表-->
    <el-table v-loading="loading" :data="tableData" :header-cell-style="{ background: '#e8f0f9', color: '#3a6ea5' }"
      style="width: 100%">
      <el-table-column border label="序号" prop="id"></el-table-column>
      <el-table-column border label="模板类型" prop="file_type"></el-table-column>
      <el-table-column border label="模板文件名" min-width="200" prop="file_name">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDownload(scope.row)">{{ scope.row.file_name }}</el-link>
        </template>
      </el-table-column>
      <el-table-column border label="最后更新时间" prop="updated_time"></el-table-column>
      <el-table-column border label="替换" min-width="120" fixed="right">
        <template slot-scope="scope">
          <el-upload class="upload-demo btn inline-block" name="upload_file" :on-success="uploadSuccess"
            :show-file-list="false" action="https://dq-back.wzfire.com/change_template" :headers="headers"
            :multiple="false" accept=".docx" :data="{ id: scope.row.id }">
            <el-button type="primary" size="mini" plain text style="margin-bottom: 10px;">上传替换</el-button>
          </el-upload>
        </template>
      </el-table-column>

    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      headers: { Authorization: this.$Config.userinfo.token },
      loading: false,
      currentConfig: {},
      tableData: [],
      pagination: { current_page: 1, total: 1, per_page: 10 },
      query: { file_name: "" },
      searchConfig: [
        { key: "file_name", label: "模板文件名", type: "input" },
        {
          key: "file_type", label: "模板类型", type: "select", list: [
            { label: "初检报告模板", value: "初检报告模板" },
            { label: "复检报告模板", value: "复检报告模板" }
          ]
        },
      ]
    }
  },
  computed: {
    ...mapGetters(['hasPermission']),
  },
  methods: {
    //上传成功
    async uploadSuccess(response, file, fileList) {
      this.$message.success("上传成功");
    },
    async handleDownload(row) {
      try {
        if (row.file_url) {
          window.open(row.file_url);
        } else {
          this.$message.error("文件 URL 不存在");
        }
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        file_name: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("report_templates", { params: params });
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style scoped>
.small-upload {
  width: 50px;
  height: 50px;
}
</style>